'use client';

import { useEffect } from 'react';
import Link from 'next/link';
import { ErrorState } from '@/src/components/ui-kontora/error-state';

export default function LoginError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    if (typeof console !== 'undefined') {
      console.error('Login error boundary:', error);
    }
  }, [error]);

  return (
    <main className="grid min-h-screen place-items-center bg-[var(--k-color-bg-app)] px-6 py-12">
      <div className="w-full max-w-md space-y-4">
        <p className="text-center text-xs font-bold uppercase tracking-[0.2em] text-[var(--k-color-danger)]">
          Anmeldung fehlgeschlagen
        </p>
        <ErrorState
          title="Die Anmeldemaske konnte nicht geladen werden"
          description="Bitte versuche es nochmal. Bleibt der Fehler, wende dich an den Support."
          requestId={error.digest}
          onRetry={reset}
          retryLabel="Erneut versuchen"
        />
        <div className="text-center">
          <Link
            href="/login"
            className="text-sm font-medium text-[var(--k-color-text-link)] underline-offset-2 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--k-color-focus-ring)] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--k-color-bg-app)]"
          >
            Seite neu laden
          </Link>
        </div>
      </div>
    </main>
  );
}
